import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'cx_foundations-how_can_i_help_to_help_center_next-click';

/**
 * Tracking the next btn from "How can I help you" to "Help center articles"
 */
export function trackCxFoundationsHowCanIHelpToHelpCenterNextClick(
  issueTree: string,
  retailerToken: string,
  brandToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { issueTree, retailerToken, brandToken },
  });
}
